<!--Title Section-->
<app-title-jumbo title="Dashboard" comment="Overview of your activity"></app-title-jumbo>

<div class="my-container">
  <section>
    <div class="container pt-3">

      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" class="stats-cards">
        <mat-card *ngIf="totalAUM && currencyBreakdown" fxFlex="33.3" style="height: 305px" class="item-inner shadow rounded" cdkDrag>
          <div class="text-center" cdkDragHandle>
            <h3 title="Asset Under Management">Asset Under Management</h3>
          </div>
          <div class="myHandle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
              <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
              <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
          </div>
          <mat-divider></mat-divider>
          <app-card-aum [total]="totalAUM | number:'1.0':'en-US'" [currencyBreakdown]="currencyBreakdown"></app-card-aum>
        </mat-card>

        <mat-card fxFlex="33.3" style="height: 305px" class="item-inner shadow rounded" cdkDrag>
          <div class="text-center" cdkDragHandle>
            <h3 title="The Factor Intensity is a measure of aggregate factor exposure to the rewarded risk factors. A strategy with high factor intensity can be regarded as having higher aggregate exposure to the rewarded risk factors.">Factor Intensity</h3>
          </div>
          <div class="myHandle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
              <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
              <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
          </div>
          <mat-divider></mat-divider>
          <app-card-chart-intensity *ngIf="intensityChart" [data]="intensityChart"></app-card-chart-intensity>
        </mat-card>

        <mat-card fxFlex="33.3" style="height: 305px" class="item-inner shadow rounded" cdkDrag>
          <div class="text-center" cdkDragHandle>
            <h3 title="Rating Breakdown">Rating Breakdown</h3>
          </div>
          <div class="myHandle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
              <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
              <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
          </div>
          <mat-divider></mat-divider>
          <app-card-chart-ratings *ngIf="ratingChart" [data]="ratingChart"></app-card-chart-ratings>
        </mat-card>
      </div>

      <br>
      <mat-divider></mat-divider>
      <br>

      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" class="stats-cards">
        <mat-card fxFlex="55" style="height: 400px" class="item-inner shadow rounded" cdkDrag>
          <div class="text-center" cdkDragHandle>
            <h3 title="My Portfolio">My Portfolio</h3>
          </div>
          <div class="myHandle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
              <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
              <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
          </div>
          <mat-divider></mat-divider>
          <div class="mat-elevation-z8">
            <table *ngIf="dataSource" mat-table [dataSource]="dataSource">

              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
              </ng-container>

              <!-- Zone Column -->
              <ng-container matColumnDef="zone">
                <th mat-header-cell *matHeaderCellDef> Zone </th>
                <td mat-cell *matCellDef="let element"> {{element.investment_zone.name}} </td>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="weight">
                <th mat-header-cell *matHeaderCellDef> Weight </th>
                <td mat-cell *matCellDef="let element"> {{ element.aum/totalAUM | percent:'.2' }} </td>
              </ng-container>

              <!-- Creation Date Column -->
              <ng-container matColumnDef="creationDate">
                <th mat-header-cell *matHeaderCellDef> Date </th>
                <td mat-cell *matCellDef="let element"> {{element.creation_date | date:'d MMM y' }} </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons [hidePageSize]="true"></mat-paginator>
          </div>
        </mat-card>

        <mat-card *ngIf="zoneChart" fxFlex="45" style="height: 400px" class="item-inner shadow rounded" cdkDrag>
          <div class="text-center" cdkDragHandle>
            <h3 title="Investment Zone">Investment Zone</h3>
          </div>
          <div class="myHandle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
              <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
              <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
          </div>
          <mat-divider></mat-divider>
          <app-basic-donut-chart [data]="zoneChart"></app-basic-donut-chart>
        </mat-card>
      </div>

    </div>
  </section>

  <br><br><br><br><br><br><br><br><br><br><br>
</div>
